import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import Recorder from "./recorder";
import ResultBox from "./ResultBox";
import ScoreCard from "./ScoreCard";
import SpacingBox from "./Spacing";
import HeadingPage from "./Heading";
import AudioPlayer from "./AudioPlayer";
import { useState } from "react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import useFetchData from "../fetchpostData";
import ScoreBox from "./ResponseBox";
import Notification from "./Notification";
import Timers from "../PageComponent/Timers";

export default function RepeatSentencePage(props) {
  const { title } = useParams();

  const section = "repeatsentence";
  const practiceItemId = title;

  const post = useFetchData(section, title); // Use the hook
  const [originalWords, setOriginalWords] = useState("");
  const [loading, setLoading] = useState(false);
  const [audioLink, setaudioLink] = useState("");
  const [text, setText] = useState("");
  const [userId, setUserId] = useState("");
  const [username, setUsername] = useState("");
  const [practiceType, setPracticeType] = useState("");
  const [isAttempted, setIsAttempted] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [savedPractice, setSavedPractice] = useState(null); // New state to store saved practice data
  const [recordedBlob, setRecordedBlob] = useState(null);


  useEffect(() => {
    console.log("Post Data :", post);

    if (post && post.media_link) {
      setOriginalWords(post.audio_script);

      // Extract file name from media_link
      const fileName = encodeURIComponent(post.media_link.split("/").pop());

      // Fetch the signed URL from the backend
      fetch(`/ptedata/ptemedia/${fileName}`, { credentials: "include" }) // Ensure cookies/session are sent
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setaudioLink(data.url); // Set the signed URL as the image source
          } else {
            console.error("Failed to fetch image URL");
          }
        })
        .catch((error) => console.error("Error fetching signed URL:", error));
    }
  }, [post]);

  console.log("Audio Link:", audioLink);
  console.log("User Spoken Text:", text);
  console.log("Original Word:", originalWords);

  const savePractice = async (practiceData) => {
    try {
      const response = await fetch("/api/save-repeatsentence", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(practiceData),
      });

      if (!response.ok) {
        throw new Error("Failed to save practice data");
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const [result, setResult] = useState("");

  useEffect(() => {
    const highlightMatchingWords = () => {
      const words1 = originalWords.split(" ");
      const words2 = text.split(" ");

      const highlightedResult = words2.map((word2, index) => {
        if (words1.includes(word2)) {
          return (
            <span
              key={index}
              style={{ backgroundColor: "#CBFB8A", marginRight: "4px" }}
            >
              {word2}
            </span>
          );
        } else {
          return (
            <span
              key={index}
              style={{ backgroundColor: "#E74C3C", marginRight: "4px" }}
            >
              {word2}
            </span>
          );
        }
      });

      setResult(highlightedResult);
    };

    highlightMatchingWords();
  }, [originalWords, text]);

  console.log("Highlighted Text", result);

  const [submitted, setSubmitted] = useState(false);

  // const handleSubmit = async (e) => {
  //   const answer = text;
  //   const practiceType = section;

  //   e.preventDefault();
  //   setLoading(true);

  //   const practiceData = {
  //     practiceType,
  //     practiceItemId,
  //     response: {
  //       questionId: practiceItemId,
  //       answer,
  //       isAttempted,
  //     },
  //   };
  //   console.log("practiceData:", practiceData);
  //   try {
  //     const result = await savePractice(practiceData);
  //     console.log("Practice data saved:", result);
  //     setMessage("Practice data saved successfully!");
  //     setNotificationType("success");
  //     setSavedPractice(result);
  //     setShowNotification(true); // Show notification

  //     setTimeout(() => {
  //       setIsAttempted(true);
  //       setLoading(false);
  //       setSubmitted(true);
  //     }, 2000);
  //   } catch (error) {
  //     console.error("Error saving practice data:", error);
  //     setMessage("Failed to save practice data.");
  //     setNotificationType("error");
  //     setShowNotification(true); // Show notification
  //     setLoading(false);
  //     setSubmitted(false);
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!recordedBlob) {
      alert("Please record audio first before submitting.");
      return;
    }
  
    setLoading(true);
  
    try {
      // ----------------------------
      // 1️⃣ Upload audio to DigitalOcean
      // ----------------------------
      const audioForm = new FormData();
      audioForm.append("audio", recordedBlob, "recording.wav");
  
      const uploadRes = await fetch("/api/upload-audio", {
        method: "POST",
        body: audioForm,
      });
  
      if (!uploadRes.ok) {
        throw new Error("Audio upload failed");
      }
  
      const uploadData = await uploadRes.json();
  
      if (!uploadData.audioUrl) {
        throw new Error("Audio URL missing from upload response");
      }
  
      const audioUrl = uploadData.audioUrl;
  
  
      // ----------------------------
      // 2️⃣ Transcribe audio
      // ----------------------------
      const transcribeForm = new FormData();
      transcribeForm.append("audio", recordedBlob, "recording.wav");
  
      const transRes = await fetch("/api/transcribe", {
        method: "POST",
        body: transcribeForm,
      });
  
      if (!transRes.ok) {
        throw new Error("Transcription request failed");
      }
  
      const transData = await transRes.json();
  
      if (!transData.text) {
        throw new Error("Transcription failed to return text");
      }
  
      const transcribedText = transData.text;
      setText(transcribedText); // update UI
  
  
      // ----------------------------
      // 3️⃣ Save practice (send to your scoring API)
      // ----------------------------
      const practiceData = {
        practiceType: section,
        practiceItemId,
        response: {
          questionId: practiceItemId,
          audioUrl: audioUrl,
          answer: transcribedText,
          isAttempted: true,
        },
      };
  
      const result = await savePractice(practiceData);
  
      setMessage("Practice data saved successfully!");
      setNotificationType("success");
      setSavedPractice(result);
      setShowNotification(true);
  
      setTimeout(() => {
        setIsAttempted(true);
        setLoading(false);
        setSubmitted(true);
      }, 1000);
    } catch (error) {
      console.error("Submit error:", error);
      setMessage(error.message || "Something went wrong.");
      setNotificationType("error");
      setShowNotification(true);
  
      setLoading(false);
      setSubmitted(false);
    }
  };
  
  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  console.log("savedPractice", savedPractice);

  // Callback function to handle the isAttempted value from the child component
  const handleIsAttempted = (isAttemptedValue) => {
    setIsAttempted(isAttemptedValue);
  };

  const attemptedStatus = isAttempted ? "Attempted" : "Not Attempted";

  return (
    <div>
      <Headerdash />
      <Sidebar />
      <div className="relative md:left-72 left-0 md:ml-3 top-28 bg-gray-100 h-auto w-full md:w-[1150px] rounded-sm p-4 ">
        <HeadingPage
          title="Question"
          timer={<Timers initialSeconds={0} />} // Use the Timer component here
          difficulty="Medium"
          attempted={attemptedStatus}
        />
        <h3 class="mx-auto px-4 text-base sm:text-lg md:text-xl lg:text-lg leading-relaxed">
          You will hear a sentence. Please repeat the sentence exactly as you
          hear it. You will hear the sentence only once.
        </h3>
        <div className="flex flex-col md:flex-row">
          <div className="flex-1 w-full md:w-1/2">
            {audioLink && <AudioPlayer audioSrc={audioLink} autoStartIn={5}  />}
          </div>
          <div className="flex-1 w-full md:w-1/2">
          <Recorder
            text={text}
            setText={setText}
            onRecordingComplete={(blob) => setRecordedBlob(blob)} // ✅ Get blob from child
            {...props}
            duration={35}
            className="mt-5 mb-5 bg-gray-100 w-[440px] h-56 border-4"
          />
          </div>
        </div>

        <button
          className="bg-blue-800 hover:bg-blue-500 text-white font-semibold py-2 px-10 rounded-sm mt-3 ml-1 w-full max-w-[345px] sm:w-auto sm:ml-6"
          onClick={handleSubmit}
        >
          {loading ? (
            <span className="flex items-center justify-center">
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              <span>Submitting...</span>
            </span>
          ) : (
            "Submit"
          )}
        </button>
        {submitted ? (
          <>
            <ResultBox result={result} />
            <ScoreCard
              finalScore={savedPractice?.savedResponse.totalScore}
              remarks={savedPractice?.savedResponse.remarks}
              contentScore={savedPractice?.savedResponse.contentScore}
              fluencyScore={savedPractice?.savedResponse.fluencyScore}
              pronounctionScore={savedPractice?.savedResponse.pronounctionScore}
            />
          </>
        ) : null}
        <ScoreBox
          originalWords={originalWords}
          practiceItemId={practiceItemId}
          onIsAttempted={handleIsAttempted}
        />
        <SpacingBox />
      </div>

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
}
